export default __webpack_public_path__ + "images/20_habitat.jpg";